/**
 * Runtime polyfills para engines antigas da matriz oficial (Tizen 6.5 = Chromium ~85,
 * WebView Android antigo). O esbuild/Vite transpila SINTAXE, mas NÃO adiciona métodos de
 * runtime novos — então `Array.prototype.at` / `String.prototype.at` (ES2022, só a partir
 * do Chrome 92) NÃO existem no Chromium 85.
 *
 * Sintoma real (SSSP Tizen 6.5, 2026-07-21): o logger do LogRocket (`cdn.logr-in.com`)
 * chama `.at()` num handler de `PerformanceObserver` (CLS) que dispara periodicamente →
 * `TypeError: this._clsSessionEntries.at is not a function` → CRASH repetido (20×/boot),
 * congelando o player no meio da reprodução.
 *
 * Idempotente: só instala onde o método NÃO existe (no-op em navegadores modernos). DEVE
 * ser importado ANTES de qualquer código que use `.at()` (topo do entry `index.tsx`,
 * antes do LogRocket subir via `useLogRocket`).
 */

interface Indexable {
  readonly length: number;
  [i: number]: unknown;
}

function polyAt(this: Indexable, index: number): unknown {
  const len = this.length;
  let i = Math.trunc(index) || 0;
  if (i < 0) i += len;
  return i < 0 || i >= len ? undefined : this[i];
}

function install(proto: object, method: string, impl: unknown): void {
  if (typeof (proto as Record<string, unknown>)[method] !== 'function') {
    Object.defineProperty(proto, method, {
      value: impl,
      writable: true,
      configurable: true,
    });
  }
}

// ES2022 `.at()` — o que crasha o LogRocket no Chromium 85.
install(Array.prototype, 'at', polyAt);
install(String.prototype, 'at', polyAt);
